import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button/button';
import styles from './resetPasswordSentPage.module.css';
import CustomFrame from '../../components/CustomFrame/customFrame';
import routes from '../../utils/routes';
import usePageTitle from '../../hooks/title.hook';

/**
 * パスワードリセットのメール送信完了ページ
 */
function ResetPasswordSentPage() {
  const navigate = useNavigate();

  usePageTitle('パスワードリセット');

  return (
    <CustomFrame
      title="パスワードリセットメール送信完了"
      desc={(
        <div className={styles.descTitle}>
          <p className={styles.firstParagraph}>
            パスワードリセットメールを送信しました。メールの内容に従いパスワードをリセットしてください。
          </p>
          <p className={styles.secondParagraph}>
            パスワード変更通知メールが届かない場合は、メールアドレスに誤りがある可能性があります。
            <br />
            正しいメールアドレスをご確認の上、再度お試しください。
          </p>
        </div>
      )}
      body={<Button content="ログイン画面へ" onClick={() => navigate(routes.login)} />}
    />
  );
}

export default ResetPasswordSentPage;
